import {
  ADMIN,
  INTERNATIONAL_FIELDS_EDIT,
} from "@/react/features/globalization/constants";

function isAdmin(rights) {
  const admin = (rights || []).find((right) => right.name === ADMIN);
  return admin?.value;
}

export function canEditAnyField(rights, rightKey) {
  const editRight = (rights || []).find((right) => right.name === rightKey);
  return editRight && editRight.value.length > 0;
}

export function canSeeEditOption(rights) {
  return isAdmin(rights) || canEditAnyField(rights, INTERNATIONAL_FIELDS_EDIT);
}

export function hasRightsForAction(rights, actionName) {
  const isUserAdmin = isAdmin(rights);
  if (isUserAdmin) {
    return true;
  }
  const columnsCanEdit = rights.find((right) => right.name === actionName);
  if (!columnsCanEdit) {
    return false;
  }
  return columnsCanEdit.value;
}

export function canEditColumn(rights, category, column) {
  const isUserAdmin = isAdmin(rights);
  if (isUserAdmin) {
    return true;
  }
  const columnsCanEdit = rights.find((right) => right.name === category);
  if (!columnsCanEdit) {
    return false;
  }
  return columnsCanEdit.value.includes(column.meta?.right);
}

export function canEditField(rights, category, field) {
  return canEditColumn(rights, category, { meta: { right: field } });
}

export function canDelete(rights, rightToDelete) {
  return hasRightsForAction(rights, rightToDelete);
}
